/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb105Inputs */

const en__field_enum_pbs_fb105 = /** @type {(inputs: _Field_Enum_Pbs_Fb105Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 10 Faculty of Modern Languages`)
};

const de__field_enum_pbs_fb105 = /** @type {(inputs: _Field_Enum_Pbs_Fb105Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 10 Neuere Philologien`)
};

/**
* | output |
* | --- |
* | "F 10 Faculty of Modern Languages" |
*
* @param {_Field_Enum_Pbs_Fb105Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb105 = /** @type {((inputs?: _Field_Enum_Pbs_Fb105Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb105Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb105(inputs)
	return de__field_enum_pbs_fb105(inputs)
});
export { _field_enum_pbs_fb105 as "_field_enum_PBS_FB10" }